(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework', [
      'complianceFrameworkApp.core'
    ]);
})();
